import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { ProgressBar, Card } from 'shared/components';
import './TrainingModules.scss';

const TrainingModules = ({ modules, small = false, completedAll = false }) => {
  const { t } = useTranslation();
  const classes = {
    'training-modules': true,
    small,
  };

  const orderedModules = orderBy(modules, ['position']);

  return (
    <div className={classnames(classes)}>
      {!orderedModules.length && (
        <div className="alert alert-primary border-0">
          {completedAll
            ? t('training.completedModulesAlert')
            : t('training.noCompletedModulesAlert')}
        </div>
      )}
      {orderedModules.map((module, i) => (
        <Module module={module} key={module.id} small={small} isActive index={i} />
      ))}
    </div>
  );
};

TrainingModules.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  small: PropTypes.bool,
  completedAll: PropTypes.bool,
};

const Module = ({ module, small = false, index, isActive }) => {
  const { t } = useTranslation();
  // let moduleNr = 1;
  let colorClass = '';
  const getStatus = (mod, i, isComplete) => {
    let label = t('training.getStartedStatusLabel');
    colorClass = 'text-pacific-blue';
    if (isComplete) {
      label = t('common.labels.completed');
      colorClass = 'text-capitalize text-green';
    } else if (i === 0) {
      colorClass = 'text-pacific-blue';
      label = t('training.getStartedStatusLabel');
    }
    // else if (i === 1) {
    //   colorClass = 'text-dark-goldenrod';
    //   moduleNr = mod.position - 1;
    //   label = t('training.completeModuleLabel', { number: moduleNr });
    // }

    return (
      <p>
        <span>{t('common.labels.status')}: </span>
        <span className={`text-strong ${colorClass}`}>{label}</span>
      </p>
    );
  };
  const completedSubs = module.submodules.filter((submodule) =>
    submodule.tasks.every((task) => task.completed)
  );
  const titleLabel = small ? 'training.moduleNumber' : module.name;
  const progressProps = {
    maxValue: module.submodules.length,
    current: completedSubs.length,
    total: module.submodules.length,
    labelAddon: small ? '' : t('common.labels.completed'),
  };
  const isComplete = progressProps.current === progressProps.total;
  const status = getStatus(module, index, isComplete);
  const showProgress = small ? true : !isComplete;
  const children = (
    <div className="module-content">
      {small && <h5 className="fw-bold">{module.name}</h5>}
      <h5>{t(titleLabel, { number: module.position })}</h5>
      {!small && status}
      {showProgress && <ProgressBar {...progressProps} />}
    </div>
  );

  return (
    <Card small={small} className={isActive || isComplete ? 'active' : ''}>
      {isActive || isComplete ? (
        <Link to={`/training/${module.id}`}>
          {children}
          {!small && (
            <i className="material-icons md-48 chevron text-pacific-blue">chevron_right</i>
          )}
        </Link>
      ) : (
        children
      )}
    </Card>
  );
};

export default TrainingModules;

Module.propTypes = {
  module: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    submodules: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  small: PropTypes.bool,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
};
